module.exports = __webpack_public_path__ + "img/ytss_logo.abaf3789.jpg";